import { type ReactNode } from 'react'

/** Labelled filter control: small muted label above the input. */
export function FilterField({
  label,
  children
}: {
  label: string
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </div>
  )
}
